import React from 'react'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import Patient from '@/v2/containers/patient'
import Search from '@/v2/containers/search'
import Calendar from '@/v2/containers/calendar'
import Login from '@/v2/containers/auth-login'
import NewPassword from '@/v2/containers/auth-new-password'
import ResetPassword from '@/v2/containers/auth-reset-password'
import InsuranceForm from '@/v2/containers/insurance-form'
import HealthHistoryForm from '@/v2/containers/health-history-form'
import MobileAppointmentDetails from '@/v2/containers/appointment/MobileAppointmentDetails'
import MobileAppointmentEdit from '@/v2/containers/appointment/MobileAppointmentEdit'
import MobileNewEvent from '@/v2/containers/appointment/MobileNewEvent'
import MobileMessages from '@/v2/containers/messages/mobile'
import NewConversation from '@/v2/containers/messages/NewConversation'
import {
  MobileEditPatientBasicInfo,
  MobileEditPatientContactInfo,
} from '@/v2/containers/patient/MobilePatientEdit'

const PatientRedirect = () => {
  const { id } = useParams()
  return <Navigate to={`/v2/patient/${id}/profile`} replace />
}

const ExternalRedirect = ({ to }) => {
  React.useEffect(() => {
    window.location.href = to
  }, [to])
  return null
}

const MobileMainRoutes = ({ location }) => {
  const rootPath = `/v2/search`
  return (
    <Routes location={location}>
      <Route path="/v2/calendar/:view/:date" element={<Calendar />} />
      <Route path="/v2/calendar/:view" element={<Calendar />} />
      <Route path="/v2/calendar" element={<Calendar />} />
      <Route path="/v2/search" element={<Search />} />
      {/* Mobile Messages Routes */}
      <Route path="/v2/messages/new/:phone" element={<NewConversation />} />
      <Route
        path="/v2/messages/start-conversation/:patientId"
        element={<NewConversation />}
      />
      <Route path="/v2/messages/:conversationId" element={<MobileMessages />} />
      <Route path="/v2/messages" element={<MobileMessages />} />
      {/* Mobile Appointment Routes - Full Screen */}
      <Route path="/v2/event/new" element={<MobileNewEvent />} />
      <Route
        path="/v2/appointment/:id/edit"
        element={<MobileAppointmentEdit />}
      />
      <Route
        path="/v2/appointment/:id"
        element={<MobileAppointmentDetails />}
      />
      {/* Mobile Patient Edit Routes - Full Screen */}
      <Route
        path="/v2/patient/:id/edit/basic"
        element={<MobileEditPatientBasicInfo />}
      />
      <Route
        path="/v2/patient/:id/edit/contact-info"
        element={<MobileEditPatientContactInfo />}
      />
      {/* Patient Routes - more specific routes first */}
      <Route
        path="/v2/patient/:id/:view/progression/:progression/series/:series"
        element={<Patient />}
      />
      <Route
        path="/v2/patient/:id/:view/progression/:progression"
        element={<Patient />}
      />
      <Route path="/v2/patient/:id/:view" element={<Patient />} />
      <Route path="/v2/patient/:id" element={<PatientRedirect />} />
      <Route path="/v2" element={<Navigate to={rootPath} replace />} />
      <Route path="/settings" element={<ExternalRedirect to="/settings" />} />
      {/* Authentication Routes */}
      <Route path="/v2/login" element={<Login />} />
      <Route path="/v2/new-password" element={<NewPassword />} />
      <Route path="/v2/reset-password" element={<ResetPassword />} />
      {/* End Authentication Routes */}
      <Route
        path="/v2/insurance-form/:patientHashId"
        element={<InsuranceForm />}
      />
      <Route
        path="/v2/health-history-form/:uuid"
        element={<HealthHistoryForm mode="fill" />}
      />
      <Route path="/500" element={<ExternalRedirect to="/500" />} />
      <Route path="*" element={<ExternalRedirect to="/v2" />} />
    </Routes>
  )
}

export default MobileMainRoutes
